import { createDecorator } from 'vue-class-component';
import { debounce } from 'lodash';

export const Debounce = (debounceTimeInMillisecond: number) => (target: any, prop: string) => {
  return {
    configurable: true,
    enumerable: false,
    value: debounce(target[prop], debounceTimeInMillisecond)
  };
};

export function Getter(getterType: string) {
  return createDecorator((options, key) => {
    if (!options.computed) {
      options.computed = {};
    }
    options.computed[key] = function() {
      return (this.$store as any).getters[getterType];
    };
  });
}
